<template>
    <single-card :wide="true">
        <slot />
    </single-card>
</template>

<script>
    import SingleCard from "./single-card.vue"

    export default {
        components: { SingleCard },
        data() {
            return {}
        }
    }
</script>

<style scoped>
</style>